import { render, staticRenderFns } from "./order_type_statistics.vue?vue&type=template&id=f03bd0b8&scoped=true"
import script from "./order_type_statistics.vue?vue&type=script&lang=js"
export * from "./order_type_statistics.vue?vue&type=script&lang=js"
import style0 from "./order_type_statistics.vue?vue&type=style&index=0&id=f03bd0b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03bd0b8",
  null
  
)

export default component.exports